import { FC, useState } from 'react';

export interface EllipsisThreeDotsButtonIconProps {
  width?: number;
  height?: number;
  className?: string;
}

/**
 * Кнопка «три точки»: серый фон, три белые точки по горизонтали.
 * Для нижней панели группового звонка.
 */
export const EllipsisThreeDotsButtonIcon: FC<EllipsisThreeDotsButtonIconProps> = ({
  width = 48,
  height = 48,
  className = '',
}) => {
  const [hover, setHover] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-hidden
    >
      <title>Инструменты</title>
      <rect width="48" height="48" rx="10" fill={hover ? '#6F6F6F' : '#828282'} />
      <path
        d="M29 23.6367C29 24.189 29.4477 24.6367 30 24.6367C30.5523 24.6367 31 24.189 31 23.6367C31 23.0844 30.5523 22.6367 30 22.6367C29.4477 22.6367 29 23.0844 29 23.6367Z"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 23.6367C23 24.189 23.4477 24.6367 24 24.6367C24.5523 24.6367 25 24.189 25 23.6367C25 23.0844 24.5523 22.6367 24 22.6367C23.4477 22.6367 23 23.0844 23 23.6367Z"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 23.6367C17 24.189 17.4477 24.6367 18 24.6367C18.5523 24.6367 19 24.189 19 23.6367C19 23.0844 18.5523 22.6367 18 22.6367C17.4477 22.6367 17 23.0844 17 23.6367Z"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
